import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';
import type { PaymentEventDef } from '../../../master-data/types/payment-event.types.ts';

// payment_event — 결제 이벤트 v2 정의. 항상 1개만 active(운영자가 admin/apply 로 전환).
// tiers 는 JSONB(threshold_vx/rewards 배열) → kind:'json' 필드로 통째 보존.
export const PaymentEventSchema = defineSchema({
  name: 'serverPaymentEvents',
  fields: [
    ['id', 'number'],
    ['active', 'boolean'],
    ['start_at', 'number'],
    ['end_at', 'number'],
    ['grace_days', 'number'],
    ['title_key', 'string?'],
    ['tiers', { kind: 'json' }],
  ],
  lookupKeys: ['id'],
});

export interface RawPaymentEventRow {
  id: number;
  active: boolean;
  start_at: number;
  end_at: number;
  grace_days: number;
  title_key: string | null;
  tiers: PaymentEventDef['tiers'];
}

export function paymentEventFromRaw(row: RawPaymentEventRow): PaymentEventDef {
  return {
    id: Number(row.id),
    active: Boolean(row.active),
    start_at: Number(row.start_at),
    end_at: Number(row.end_at),
    grace_days: Number(row.grace_days),
    title_key: row.title_key ?? undefined,
    tiers: row.tiers ?? [],
  };
}

registerCategorySchema('serverPaymentEvents', PaymentEventSchema);
